import { DateTime, Interval } from "luxon";
import i18n from "@/i18n";
import FreeDaysModule from "../../store/planning/freeDaysStore";

import {
  getAllLeavePeriodsHttp,
  getLeavePeriodsByUserIdHttp,
  fetchAllLeavePeriodsFromDG2Http,
  getLeavePeriodsBetweenHttp,
  countLeavePeriodsByUserType,
} from "../../services/planning/LeavePeriodService.js";

const state = {
  leavePeriods: [],
  leavePeriodsEmployee: [],
};

const getters = {
  getLeavePeriods(state) {
    return state.leavePeriods;
  },
};

const mutations = {
  SET_LEAVEPERIODS: (state, data) => (state.leavePeriods = data),
  SET_LEAVEPERIODS_EMPLOYEE: (state, data) =>
    (state.leavePeriodsEmployee = data),
  NEW_LEAVEPERIODS: (state, payload) => state.leavePeriods.push(payload),
};

const actions = {
  // /**
  //  * This method will load all leave periods from the database
  //  *
  //  * @param  {vueX} {commit necessary if call commit inside the method
  //  * @param  {vueX} dispatch} necessary if call dispatch inside the method
  //  * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_LEAVEPERIODS", response.data)
  //  */
  // async loadLeavePeriods({ commit, dispatch }) {
  //   await getAllLeavePeriodsHttp()
  //     .then((response) => commit("SET_LEAVEPERIODS", response.data))
  //     .catch((error) => {
  //       dispatch(
  //         "notificationModule/showNotification",
  //         {
  //           messageAlert: i18n.t("messageStores.leavePeriodAllError"),
  //           typeAlert: "error",
  //         },
  //         { root: true }
  //       );
  //     });
  // },

  /**
   * This method will create the leavePeriod object necessary for the proper functioning of the calendar in the Front-End.
   *
   * @param  {Vuex} {rootGetters} necessary if call getters from another store
   * @param  {Object - leavePeriodDto} lPeriod leave period received from the Rest API that we need to transform in order to be able to be displayed in the calendar
   * @returns {Object - leavePeriod Front-End} return a leave period that can be used by the calendar in the Front-End
   */
  async createFrontLeavePeriodObject({ rootGetters }, lPeriod) {
    let leavePeriod = lPeriod.lp;

    const posY = await rootGetters["userModule/getOnUserDisplay"].findIndex(
      (u) => u.id === leavePeriod.employeeId
    );

    let dateStartForTest = new Date(leavePeriod.firstDay);
    const dateEnd = new Date(leavePeriod.lastDay);

    let effectiveDuration = leavePeriod.days;

    while (dateStartForTest <= dateEnd) {
      let dateTestFormated = FreeDaysModule.methods.formatDate(
        new Date(dateStartForTest)
      );
      if (
        FreeDaysModule.methods.isWeekEndDay(dateTestFormated) ||
        FreeDaysModule.methods.isHoliDay(dateTestFormated)
      ) {
        effectiveDuration++;
      }
      dateStartForTest.setDate(dateStartForTest.getDate() + 1);
    }

    let gridObject = {
      y: posY,
      x: leavePeriod.firstDay.substring(0, 10),
      id: "LV" + leavePeriod.id,
      employeeId: leavePeriod.employeeId,
      employee: leavePeriod.employeeFullName,
      duration: effectiveDuration,
      startsAfternoon: leavePeriod.startsAfternoon,
      endsAfternoon: leavePeriod.endsAfternoon,
      display: true,
      details: leavePeriod,
      color: "#dbdbdb",
      type: leavePeriod.type,
      eventSiblings: [],
    };

    return gridObject;
  },
  /**
   * This method will load events present between the interval (currentDate - 2 months) to (currentDate + 2 months)
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} getters necessary if call getters inside the method
   * @param  {Vuex} rootGetters necessary if call getters from another store
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {} currentDate the date where the client is located in the calendar
   * @returns {} it is returning nothing because the response will be load in the store directly
   */
  async loadLeavePeriods(
    { commit, getters, rootGetters, dispatch },
    currentDate
  ) {
    let timePrediod = rootGetters["eventModule/getTimePeriod"];

    let dateStart = null;
    let dateEnd = null;

    switch (timePrediod) {
      case "year":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("year");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("year")
            .plus({ year: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate.plus({ year: 1 }).plus({ week: 1 }).toISODate();
        break;
      case "quarter":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("quarter");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("quarter")
            .plus({ quarter: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate
          .plus({ quarter: 1 })
          .plus({ week: 1 })
          .toISODate();
        break;
      case "month":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("month");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("month")
            .plus({ month: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate.plus({ month: 1 }).plus({ week: 1 }).toISODate();
        break;
      case "week":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("week");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("week")
            .plus({ week: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate.plus({ week: 1 }).toISODate();
        break;
    }

    let count = await dispatch("countLeavePeriods");
    //Note: conditions to not call every time getSubInterventionsHttp once we have the total of event per Calendar (userType)
    if (
      count >
      getters.getLeavePeriods.filter(
        (e) => e.userType === rootGetters["userModule/getCalendar"]
      ).length
    ) {
      const promise = await getLeavePeriodsBetweenHttp(
        rootGetters["userModule/getCalendar"],
        dateStart,
        dateEnd
      );

      const promises = promise.data.map((lp) => {
        return dispatch("createFrontLeavePeriodObject", { lp });
      });

      state.leavePeriods = await Promise.all(promises);
    }
    // await getAllLeavePeriodsHttp().then((response) => {
    //   response.data.forEach((lp) => {
    //     if (
    //       !getters.getLeavePeriods.some(
    //         (leavePeriod) => leavePeriod.id === lp.id
    //       )
    //     ) {
    //       dispatch("createFrontLeavePeriodObject", { lp }).then((res) => {
    //         commit("NEW_LEAVEPERIODS", res);
    //       });
    //     }
    //   });
    // });
  },
  /**
   * This method will give the number of leave-periods depending of the calendar selecteced (trainer, salesperson, admin, etc)
   *
   * @param  {Vuex} {rootGetters} necessary if call getters from another store
   * @returns {int} it is returning the number of leave-periods depending of the calendar selecteced
   */
  async countLeavePeriods({ rootGetters }) {
    let nb = await countLeavePeriodsByUserType(
      rootGetters["userModule/getCalendar"]
    )
      .then((response) => {
        return response.data.nb;
      })
      .catch((error) => {
        return error;
      });
    return nb;
  },
  /**
   * This method is calling the http call to get a leavePeriod in the database and then in the VueX store
   *
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {Object - leavePeriodDto} leavePeriod object that we want to get in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_LEAVEPERIODS_EMPLOYEE", response.data)
   */
  async getLeavePeriodsByEmployeeId({ commit, dispatch }, employeeId) {
    await getLeavePeriodsByUserIdHttp(employeeId)
      .then((response) => {
        if (response.status === 200) {
          commit("SET_LEAVEPERIODS_EMPLOYEE", response.data),
            dispatch(
              "notificationModule/showNotification",
              {
                messageAlert: i18n.t("messageStores.getleavePeriodsSuccess"),
                typeAlert: "success",
              },
              { root: true }
            );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.getLeavePeriodsError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to fetch leave periods from the webservice Wdg2
   *
   * @param  {vueX} {dispatch} necessary if call dispatch inside the method
   * @param  {Object - LogInUser} logInUser user dg2
   * @param {string - FirstDay} firstDay first day of desired interval with format date "yyyy-MM-dd"
   * @param {string - LastDay} lastDay last day of desired interval with format date "yyyy-MM-dd"
   * @returns {} it is returning nothing. The database is updated directly in the Back-End when the method is called.
   */
  async fetchLeavePeriodsDG2({ dispatch }, { logInUser, firstDay, lastDay }) {
    await fetchAllLeavePeriodsFromDG2Http(logInUser, firstDay, lastDay)
      .then((response) => {
        if (response.status === 200) {
          dispatch("loadLeavePeriods");
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t("messageStores.leavePeriodAllSuccess"),
              typeAlert: "success",
            },
            { root: true }
          );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.leavePeriodAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
};

const methods = {
  /**
   * This method checks if a given event is overlaping with existing leave-periods
   * @param {string} startDate date of the beggining of event to test
   * @param {Object} event event to test
   * @param {Object} user user whose leave-periods we want to test
   * @returns a boolean true if there are no overlaping leave-periods, false if there are overlaping leave-periods
   */
  intervalIsEmptyLeavePeriod(startDate, event, user) {
    const duration = event.duration - 1;
    let start = new Date(startDate);
    let end = new Date(startDate);
    end.setDate(end.getDate() + duration);
    let isEmpty = true;

    state.leavePeriods
      .filter((lp) => lp.employeeId === user.id)
      .forEach((lp) => {
        const lpStart = new Date(lp.details.firstDay);
        const lpEnd = new Date(lp.details.lastDay);

        if (lpStart <= end && lpEnd >= start) {
          isEmpty = false;
        }
      });
    return isEmpty;
  },
  /**
   * This method checks if a given event is overlaping with existing leave-periods
   * @param {string} startDate date of the beggining of event to test
   * @param {string} endDate date of the end of event to test
   * @param {Object} user whose leave-periods we want to test
   * @returns a boolean true if there are no overlaping leave-periods, false if there are overlaping leave-periods
   */
  intervalIsEmptyLeavePeriodStartEnd(startDate, endDate, user) {
    let start = new Date(startDate);
    let end = new Date(endDate);
    let isEmpty = true;

    state.leavePeriods
      .filter((lp) => lp.employeeId === user.id)
      .forEach((lp) => {
        const lpStart = new Date(lp.details.firstDay);
        const lpEnd = new Date(lp.details.lastDay);

        if (lpStart <= end && lpEnd >= start) {
          isEmpty = false;
        }
      });
    return isEmpty;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  methods,
};
